import { takeLatest } from 'redux-saga/effects';
import * as actionTypesNV05 from '../actions/actionTypesNV05';
import { getNV05ListSaga } from './NV05.saga';


export function* watchGetNV05ListSaga() {
  yield takeLatest(actionTypesNV05.NV05_LIST_GET, getNV05ListSaga);
}

